


import homePayload from "./HomePayload";
import callPostApi from "../../../requests/PostRequests";
import multiplePostRequests from "../../../requests/MultiplePostRequests";

import * as Constants from '../../../requests/URLConstants';
import moment from 'moment';

export async function IncidentVelocityTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return multiplePostRequests([Constants.GETALERTINCIDENTVELOCITYTREND, Constants.GETINFRAVELOCITYANDCOUNT], {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareIncidentVelocityTrend(resp);
                return { data: formattedData ? formattedData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareIncidentVelocityTrend = (response) => {
    console.log(response, "resp");
    let data1 = []; let data2 = []; let data = [];
    let objTotalTickets = {};
    let objTicketsCreated = {};
    for (let j = 0; j < response.length; j++) {
        if (response[j].data) {
            let buckets = j === 0 ? response[j].data.aggregations.client.buckets.length > 0 ? response[j].data.aggregations.client.buckets : [] : response[j].data.aggregations.Time.buckets.length > 0 ? response[j].data.aggregations.Time.buckets : [];
            if (buckets.length > 0) {
                for (let i = 0; i < buckets.length; i++) {
                    objTotalTickets = {
                        group: 'Alerts',
                        date: moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD"),
                        value: j === 0 ? (buckets[i].total.buckets.alerts.count.value).toFixed(2) : (buckets[i].total.buckets.alerts.count.value).toFixed(2)
                    };
                    objTicketsCreated = {
                        group: 'Incidents',
                        date: moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD"),
                        value: j === 0 ? (buckets[i].tickets.unique_count.value).toFixed(2) : (buckets[i].tickets.unique_count.value).toFixed(2)
                    };
                    if (j === 0) {
                        data1.push(objTotalTickets);
                        data1.push(objTicketsCreated);
                    }
                    else {
                        data2.push(objTotalTickets);
                        data2.push(objTicketsCreated);
                    }
                }
            }
        }
    }
    data1.length > 0 && data2.length > 0 &&
        data1.map((item) => {
            data2.map((dataItem) => {
                if (item['group'] === dataItem['group'] && item['date'] === dataItem['date']) {
                    item['value'] = Number(item['value']) + Number(dataItem['value']);
                }
            })
            data.push(item);
        })
    return data;
}

export async function AlertDistributionData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return multiplePostRequests([Constants.GETAPPLICATIONALERTCOUNT, Constants.GETINFRAVELOCITYANDCOUNT], {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareAlertDistributionData(resp);
                return { data: formattedData ? formattedData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareAlertDistributionData = (response) => {
    let data = [];
    let applicationAlertCount = {};
    let infraAlertCount = {};
    if (response.length) {
        let applicationAlertCountBucket = response[0].data.aggregations.Time.buckets;
        let infraAlertCountBucket = response[1].data.aggregations.Time.buckets;
        for (let i = 0; i < applicationAlertCountBucket.length; i++) {
            applicationAlertCount = {
                group: 'Application Alert',
                date: moment(new Date(applicationAlertCountBucket[i].key_as_string)).format("YYYY-MM-DD"),
                value: (applicationAlertCountBucket[i].total.buckets.alerts.app_alert_count.value).toFixed(2)
            };
            infraAlertCount = {
                group: 'Infra Alert',
                date: moment(new Date(infraAlertCountBucket[i].key_as_string)).format("YYYY-MM-DD"),
                value: (infraAlertCountBucket[i].total.buckets.alerts.count.value).toFixed(2)
            };
            data.push(applicationAlertCount);
            data.push(infraAlertCount);
        }
    }
    return data;
}

export async function IncidentConversion(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {
    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = {}, formattedSummary = [];
        return multiplePostRequests([Constants.GETALERTSKPI, Constants.GETINFRAALERTSKPI], {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareAlertsKPIData(resp);
                //formattedSummary = prepareSummaryData(formattedData.summaryData);
                console.log(formattedData, "alerts");
                let incidentConversionRatio;
                let EliminatedNoise;
                let summaryData = formattedData.summaryData ? formattedData.summaryData : {};
                if (Object.keys(summaryData).length > 0) {
                    incidentConversionRatio = (summaryData.uniqueAlerts / summaryData.totalAlerts) * 100;
                    EliminatedNoise = (((summaryData.totalDuplicateAlerts + (summaryData.totalAlerts - (summaryData.totalDuplicateAlerts + summaryData.uniqueAlerts))) / summaryData.totalAlerts) * 100).toFixed(2);
                    let informationalAlerts = Number(summaryData.totalAlerts - (summaryData.totalDuplicateAlerts + summaryData.uniqueAlerts));

                    return { data1: isNaN(incidentConversionRatio) ? 0 : incidentConversionRatio.toFixed(2), loader: false, data2: isNaN(EliminatedNoise) ? 0 : EliminatedNoise, data3: summaryData ? summaryData : {}, data4: informationalAlerts ? informationalAlerts : 0 };
                }
                else {
                    return { data1: [], loader: false, data2: [], data3: {}, data4: {} }
                }

            }).catch((error) => {
                return { data1: null, loader: false, data2: null, data3: null, data4: null };
            });
    }
}

const prepareAlertsKPIData = (response) => {
    let duplicatedAlerts = 0
    let totalAlerts = 0;
    let summaryData = {}, totalDuplicateAlerts = 0, uniqueAlerts = 0;
    for (let j = 0; j < response.length; j++) {
        let buckets = j === 0 ? response[j].data.aggregations.client.buckets.length > 0 ? response[j].data.aggregations.client.buckets : [] : response[j].data.aggregations['client name'] && response[j].data.aggregations['client name'].buckets.length > 0 ? response[j].data.aggregations['client name'].buckets : [];
        if (buckets.length > 0) {
            if (j === 0) {
                for (let i = 0; i < buckets.length; i++) {
                    duplicatedAlerts = buckets[i].total.buckets.ticketed.count.value - buckets[i].tickets.unique_count.value;
                    totalAlerts = totalAlerts + buckets[i].total.buckets.alerts.count.value;
                    uniqueAlerts = uniqueAlerts + buckets[i].tickets.unique_count.value;
                    totalDuplicateAlerts = totalDuplicateAlerts + duplicatedAlerts;
                    summaryData = {
                        totalAlerts: totalAlerts,
                        totalDuplicateAlerts: totalDuplicateAlerts,
                        uniqueAlerts: uniqueAlerts
                    }

                }
            }
            else {
                let totInfraAlerts = 0, totInfraTickets = 0, dupInfraAlerts = 0;
                for (let i = 0; i < buckets.length; i++) {
                    totInfraAlerts = totInfraAlerts + buckets[i].total.buckets.alerts.count.value;
                    totInfraTickets = totInfraTickets + buckets[i].tickets.unique_count.value; //unique alerts
                    dupInfraAlerts = dupInfraAlerts + (buckets[i].total.buckets.ticketed.count.value - buckets[i].tickets.unique_count.value);
                }

                summaryData.totalAlerts = Number(summaryData.totalAlerts) + Number(totInfraAlerts) ? Number(summaryData.totalAlerts) + Number(totInfraAlerts) : 0;
                summaryData.totalDuplicateAlerts = Number(summaryData.totalDuplicateAlerts) + Number(dupInfraAlerts) ? Number(summaryData.totalDuplicateAlerts) + Number(dupInfraAlerts) : 0;
                summaryData.uniqueAlerts = Number(summaryData.uniqueAlerts) + Number(totInfraTickets) ? Number(summaryData.uniqueAlerts) + Number(totInfraTickets) : 0;
            }
        }
    }
    return  {summaryData} ;

};



